/**
 * Newt's suggested tree spots, placed by hand with dev mode's spot editor
 * (Garden → Suggested spots → Copy for Claude) and baked in here. Tiles are
 * [column, row] on the 24×16 grid. A biome left out gets an automatic,
 * evenly spaced set instead (`suggestedSpots` in garden-map.ts).
 */
import type { Biome } from './types.js';

export const SUGGESTED_SPOTS: Partial<Record<Biome, [number, number][]>> = {};
